module.exports = __webpack_public_path__ + "static/media/primo-volo.09189b71.jpg";